module.exports = [{
      plugin: require('/Users/silvenon/Code/pubmet/node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"remarkPlugins":[],"rehypePlugins":[]},
    },{
      plugin: require('/Users/silvenon/Code/pubmet/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-27463615-2","head":true},
    },{
      plugin: require('/Users/silvenon/Code/pubmet/workspaces/2019/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
